import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Biggen } from "../directives/biggen";

@Component({
  selector: 'app-thallus',
  imports: [Biggen],
  templateUrl: './thallus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './thallus.scss',
})
export class Thallus {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Thallus`);
    this.dynamicTitle.description(`Thallus mentions a solar eclipse that would have been impossible to observe in Jerusalem during Passover.`);
  }
}
